export enum RecurrenceValue {
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
  MONTHLY = 'MONTHLY',
  MINUTELY = 'MINUTELY', // debug-only, should not be available in PROD
  EVERY_MORNING_9_AM = 'everyMorningAt9amKey',
  ONCE_WEEKLY_9_AM = 'onceWeeklyAt9amKey',
  ONCE_EVERY_OTHER_WEEK_9_AM = 'onceEveryOtherWeekAt9amKey',
  ONCE_MONTHLY = 'onceMonthlyAt9amKey',
  AS_DIRECTED = 'asDirectedKey',
  AS_NEEDED = 'asNeededKey',
  ONE_TIME = 'oneTimeRuleKey'
}

export const isUnscheduledRecurrence = (value: string | null) => {
  return value === RecurrenceValue.AS_DIRECTED || value === RecurrenceValue.AS_NEEDED;
};

export const isLegacyRecurrence = (value: string | null) => {
  return (
    value === RecurrenceValue.DAILY ||
    value === RecurrenceValue.WEEKLY ||
    value === RecurrenceValue.MONTHLY
  );
};
